export const employeesGridSwitchBadges = {
    bindings: {
        identifier: '@'
    },
    controller: 'EmployeesGridSwitchBadgesController',
    template: require('./employees-grid-switch-badges.html'),
};
